import React, { Component, lazy } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { CookiesProvider, Cookies } from 'react-cookie';
import createBrowserHistory from 'history/createBrowserHistory';
import { FloatButton, Space, Typography, Divider, ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import zhCN from 'antd/lib/locale/zh_CN';

const history = createBrowserHistory();

// Antd 全局主题配置
const antdTheme = {
    token: {
        colorPrimary: '#2b3e50',
        colorText: '#FFF',
        colorTextSecondary: '#ebebeb',
        colorTextTertiary: '#ebebeb',
    },
    components: {
        Table: {
            colorBgContainer: '#4e5d6c',
            colorText: '#FFF',
            colorBgBase: '#4e5d6c',
            colorBgLayout: '#4e5d6c',
            colorTextHeading: '#FFF',
            colorBorderSecondary: 'rgb(128,128,128, 0.6)',
            headerBg: '#5bc0de',
            headerColor: '#ebebeb',
            cellPaddingBlock: 8,
            cellPaddingBlockMD: 6,
            cellPaddingBlockSM: 4,
        },
        Modal: {
            contentBg: '#4e5d6c',
            headerBg: '#4e5d6c',
            titleColor: '#FFF',
            colorText: '#FFF',
        },
        Tag: {
            defaultBg: '#4e5d6c',
            defaultColor: '#FFF',
        },
        InputNumber: {
            colorBgContainer: '#FFF',
            colorText: '#000',
            colorTextPlaceholder: 'rgba(0,0,0,0.4)',
            colorBorder: '#5bc0de',
            hoverBorderColor: '#5bc0de',
            activeBorderColor: '#5bc0de',
            activeShadow: '0 0 0 2px rgba(91, 192, 222, 0.16)',
            colorIcon: 'rgba(43, 62, 80, 0.72)',
            handleBg: '#ffffff',
            handleActiveBg: 'rgba(91, 192, 222, 0.18)',
            handleHoverColor: '#2b3e50',
            handleBorderColor: 'rgba(91, 192, 222, 0.8)',
        },
        Card: {
            colorBgContainer: '#4e5d6c',
            colorText: '#FFF',
            headerBg: '#4e5d6c',
        },
        Tabs: {
            inkBarColor: '#5bc0de',
            itemActiveColor: '#FFF',
            itemSelectedColor: '#FFF',
            itemColor: 'rgba(255,255,255,0.7)',
            itemHoverColor: '#FFF',
        },
        Button: {
            colorPrimary: '#5bc0de',
            colorPrimaryBg: '#5bc0de',
            colorPrimaryActive: '#46b8da',
            colorPrimaryHover: '#5bc0de',
            colorPrimaryBorder: '#5bc0de',
            primaryColor: '#FFF',
            primaryShadow: 'none',
            // 取消按钮使用次颜色（浅灰）
            defaultBg: '#6c7a89',
            defaultColor: '#FFF',
            defaultBorderColor: '#6c7a89',
            defaultHoverBg: '#7a8b9a',
            defaultHoverColor: '#FFF',
            defaultHoverBorderColor: '#7a8b9a',
            defaultActiveBg: '#5a6878',
            defaultActiveColor: '#FFF',
            defaultActiveBorderColor: '#5a6878',
        },
        Dropdown: {
            colorBgElevated: '#2b3e50',
        },
        Statistic: {
            colorText: '#FFF',
            titleColor: '#FFF',
            contentColor: '#FFF',
        },
        Radio: {
            colorPrimary: '#5bc0de',
            colorBgContainer: '#4e5d6c',
            colorBorder: '#5bc0de',
            dotColorDisabled: '#5bc0de',
            buttonSolidCheckedBg: '#5bc0de',
            buttonSolidCheckedHoverBg: '#5bc0de',
            buttonSolidCheckedActiveBg: '#5bc0de',
            buttonSolidCheckedColor: '#FFF',
        },
        Pagination: {
            colorBgContainer: '#4e5d6c',
            colorText: '#FFF',
            colorPrimary: '#FFF',
            colorPrimaryHover: '#FFF',
            itemActiveBg: '#5bc0de',
            itemBg: '#4e5d6c',
            itemInputBg: '#4e5d6c',
        },
        Checkbox: {
            colorPrimary: '#5bc0de',
            colorPrimaryHover: '#46b8da',
            colorBgContainer: '#4e5d6c',
            colorBorder: '#5bc0de',
        },
        Drawer: {
            colorBgElevated: '#4e5d6c',
            colorText: '#FFF',
        },
        Spin: {
            colorPrimary: '#5bc0de',
            contentColor: '#FFF',
        },
        Divider: {
            colorSplit: 'rgba(91, 192, 222, 0.5)',
            colorText: '#FFF',
        },
        Switch: {
            colorPrimary: '#5bc0de',
            colorPrimaryHover: '#46b8da',
        },
        Popover: {
            colorBgElevated: '#4e5d6c',
            colorText: '#FFF',
            titleColor: '#FFF',
        },
        List: {
            colorBgContainer: 'transparent',
            colorText: '#FFF',
        },
        Comment: {
            colorBgContainer: 'transparent',
            colorText: '#FFF',
            contentBg: 'transparent',
        },
        Upload: {
            colorBorder: '#5bc0de',
            colorPrimaryHover: '#5bc0de',
        },
        Input: {
            colorBgContainer: '#FFF',
            colorText: '#000',
            colorBorder: '#5bc0de',
            colorTextPlaceholder: 'rgba(0,0,0,0.4)',
        },
        TextArea: {
            colorBgContainer: '#FFF',
            colorText: '#000',
            colorBorder: '#5bc0de',
        },
        Select: {
            colorBgContainer: '#FFF',
            colorText: '#000',
            colorBorder: '#5bc0de',
            colorBgElevated: '#FFF',
            optionSelectedBg: '#e6f7ff',
            optionActiveBg: '#bae7ff',
            optionSelectedColor: '#000',
            colorTextPlaceholder: 'rgba(0,0,0,0.4)',
            colorIcon: '#999',
            colorIconHover: '#5bc0de',
        },
        DatePicker: {
            colorBgContainer: '#FFF',
            colorText: '#000',
            colorBorder: '#5bc0de',
            colorBgElevated: '#FFF',
            colorTextPlaceholder: 'rgba(0,0,0,0.4)',
            colorTextHeading: '#000',
            colorIcon: '#666',
            colorIconHover: '#5bc0de',
        },
        Mentions: {
            colorBgContainer: '#FFF',
            colorText: '#000',
            colorBorder: '#5bc0de',
            colorBgElevated: '#FFF',
            colorTextPlaceholder: 'rgba(0,0,0,0.4)',
            optionSelectedBg: '#e6f7ff',
            optionActiveBg: '#bae7ff',
        },
        FloatButton: {
            colorBgElevated: '#5bc0de',
            colorText: '#FFF',
            colorPrimary: '#5bc0de',
            colorPrimaryHover: '#46b8da',
        },
    },
};
import { UpOutlined } from '@ant-design/icons';
import Gutschrift from './containers/Gutschrift';
import ShortProducts from './containers/ShortProducts';
const { Text } = Typography;
const Home = lazy(() => import("./containers/Home"));
const Orders = lazy(() => import("./containers/Orders"));
const Order = lazy(() => import("./containers/Order"));
const OrderCreatePage = lazy(() => import("./containers/Order/OrderCreatePage"));
const Storage = lazy(() => import("./containers/Storage"));
const Inventory = lazy(() => import("./containers/Inventory"));
const StorageOrder = lazy(() => import("./containers/Storage/StorageOrder"));
const Delivery = lazy(() => import("./containers/Delivery"));
const StorageOverview = lazy(() => import("./containers/StorageOverview"));
const Brands = lazy(() => import("./containers/Brands"));
const Brand = lazy(() => import("./containers/Brand"));
const BrandCreatePage = lazy(() => import("./containers/Brand/BrandCreatePage"));
const Resources = lazy(() => import("./containers/Resources"));
const Resource = lazy(() => import("./containers/Resource"));
const ResourceCreatePage = lazy(() => import("./containers/Resource/ResourceCreatePage"));
const Category = lazy(() => import("./containers/Category"));
const CategoryCreatePage = lazy(() => import("./containers/Category/CategoryCreatePage"));
const Categories = lazy(() => import("./containers/Category/CategoriesList"));
const Clients = lazy(() => import("./containers/Clients"));
const Client = lazy(() => import("./containers/Client"));
const ClientCreatePage = lazy(() => import("./containers/Client/ClientCreatePage"));
const Invoices = lazy(() => import("./containers/Invoices"));
const Invoice = lazy(() => import("./containers/Invoice"));
const InvoiceCreatePage = lazy(() => import("./containers/Invoice/InvoiceCreatePage"));
const Contracts = lazy(() => import("./containers/Contracts"));
const Contract = lazy(() => import("./containers/Contract"));
const ContractCreatePage = lazy(() => import("./containers/Contract/ContractCreatePage"));
const ContractAnalysisPage = lazy(() => import("./containers/Contract/ContractAnalysisPage"));
const Logout = lazy(() => import("./containers/Logout"));
const Login = lazy(() => import("./containers/Login"));
const Inquiry = lazy(() => import("./containers/Inquiry"));
const Inquiries = lazy(() => import("./containers/Inquiries"));
const Members = lazy(() => import("./containers/Members"));
const User = lazy(() => import("./containers/User"));
const UserSecurity = lazy(() => import("./containers/UserSecurity"));
const Payments = lazy(() => import("./containers/Payments"));
const PaymentProformas = lazy(() => import("./containers/paymentProformas"));
const PaymentCreate = lazy(() => import("./containers/Payment/create"));
const Payment = lazy(() => import("./containers/Payment/index"));
const AutoInvoices = lazy(() => import("./containers/AutoInvoices"));
const AutoInvoiceDetail = lazy(() => import("./containers/AutoInvoice"));
const BlockUsers = lazy(() => import("./containers/BlockUsers/index"));
const Permissions = lazy(() => import("./containers/Permissions/index"));
const Ztns = lazy(() => import("./containers/Ztns"));
const ZtnCreate = lazy(() => import("./containers/Ztn/create"));
const Ztn = lazy(() => import("./containers/Ztn/index"));
const Waybills = lazy(() => import("./containers/Waybills"));
const WaybillCreate = lazy(() => import("./containers/Waybill/create"));
const Waybill = lazy(() => import("./containers/Waybill/index"));
const Hscodes = lazy(() => import("./containers/Hscodes"));
const HscodeCreate = lazy(() => import("./containers/Hscode/create"));
const Hscode = lazy(() => import("./containers/Hscode/index"));
const WaybillStickerCreate = lazy(() => import("./containers/Sticker/create"));
const Incomes = lazy(() => import("./containers/Incomes"));
const IncomeCreate = lazy(() => import("./containers/Income/create"));
const Income = lazy(() => import("./containers/Income/index"));
const Todolist = lazy(() => import("./containers/Todolist"));
const MessageBar = lazy(() => import("./components/MessageBar"));
const Freights = lazy(() => import("./containers/Freights/index"));
const FreightCreate = lazy(() => import("./containers/Freight/create"));
const Freight = lazy(() => import("./containers/Freight/index"));
const Pickups       = lazy(() => import("./containers/Pickups"));
const Pickup        = lazy(() => import("./containers/Pickup"));
const Transfers = lazy(() => import("./containers/Transfers/index"));
const TransferCreate = lazy(() => import("./containers/Transfer/create"));
const Transfer = lazy(() => import("./containers/Transfer/index"));
const Buys = lazy(() => import("./containers/Buys"));
const Buy = lazy(() => import("./containers/Buy"));
const BuyCreatePage = lazy(() => import("./containers/Buy/BuyCreatePage"));
const ReportLogistics = lazy(() => import("./containers/Report/logistics"));
const ReportLogistic = lazy(() => import("./containers/Report/logistic"));
const ReportLogisticCreatePage = lazy(() => import("./containers/Report/logistic/createPage"));
const ReportOffices = lazy(() => import("./containers/Report/offices"));
const ReportOffice = lazy(() => import("./containers/Report/office"));
const ReportOfficeCreatePage = lazy(() => import("./containers/Report/office/createPage"));
const ReportVacations = lazy(() => import("./containers/Report/vacations"));
const ReportVacation = lazy(() => import("./containers/Report/vacation"));
const ReportVacationCreatePage = lazy(() => import("./containers/Report/vacation/createPage"));
const Prices = lazy(() => import("./containers/Prices"));
const Price = lazy(() => import("./containers/Price"));
const Discounts = lazy(() => import("./containers/Discounts"));
const Discount = lazy(() => import("./containers/Discount"));
const Refs = lazy(() => import("./containers/Refs"));
const Analysis = lazy(() => import("./containers/Analysis"));
const AnalysisInfo = lazy(() => import("./containers/AnalysisInfo"));
const BackOrders = lazy(() => import("./containers/BackOrders"));
const BackOrder = lazy(() => import("./containers/BackOrder"));
const BackOrderCreatePage = lazy(() => import("./containers/BackOrder/BackOrderCreatePage"));
const Wikis = lazy(() => import("./containers/Wikis"));
const Wiki = lazy(() => import("./containers/Wiki"));
const WikiCreate = lazy(() => import("./containers/Wiki/create"));
const Translate = lazy(() => import("./containers/Tools/Translate"));
const InvoiceDelivery = lazy(() => import("./containers/Invoice/InvoiceDelivery"));
const Stocks = lazy(() => import("./containers/Stocks"));
const StockCreatePage = lazy(() => import("./containers/Stocks/StockCreatePage"));
const Stock = lazy(() => import("./containers/Stock"));
const Tors = lazy(() => import("./containers/Tors"));
const Tor = lazy(() => import("./containers/Tor"));
const Tariffnumbers = lazy(() => import("./containers/Tariffnumbers"));
const ReportWorkTime = lazy(() => import("./containers/Report/WorkTime"));
// const PdfExtracts = lazy(() => import("./containers/PdfExtracts"));
// const PdfExtract = lazy(() => import("./containers/PdfExtract"));
class App extends Component {

    componentWillMount() {

        // window.live = 'http://apioffice.com/'; // Localhost
        // window.live = 'https://dev-api.office.aoidata.com/'; // Dev
        window.live = 'https://api.office.aoidata.com/'; // Live

        window.auth = window.live + 'api/auth';
        window.api = window.live + 'api/office/';
        
        window.history_update_items = [
            {
                children: <>
                    <h4>2026-10-13</h4>
                    <ul>
                        <li>
                            完善产品修改的留言记录信息，优化产品修改留言的排版。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-09-20</h4>
                    <ul>
                        <li>
                            订单状态已经是取消的订单，如果仓库要在订单页面入库（修改到货数量/勾选到货），跳出提醒，提醒同事再次确认是否入库，订单已经取消。
                        </li>
                        <li>
                            仓库同事在 AOI 到货情况 界面，隐藏 单价，总价，额外折扣，折后价，这四列。
                        </li>
                        <li>
                            AOI 到货情况的关键字搜索，支持90%匹配搜索（wuerth的必须100%匹配）。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-09-15</h4>
                    <ul>
                        <li>
                            Invoice，报关 Excel，增加导入功能。（支持excel修改后回写系统）
                        </li>
                        <li>
                            询价增加客户反馈，询价列表统计增加跟单率。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-09-11</h4>
                    <ul>
                        <li>
                            询价增加跟单标记与邮件通知。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-08-26</h4>
                    <ul>
                        <li>
                            支持导出ZUGFeRD账单。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-08-17</h4>
                    <ul>
                        <li>
                            合同列表页柱状图，支持根据筛选年份自动变更。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-08-17</h4>
                    <ul>
                        <li>
                            订单到货，列表的导出，JR的恢复之前逻辑，不显示非产品项。
                        </li>
                        <li>
                            到货情况，Excel导出，新增导出选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-08-12</h4>
                    <ul>
                        <li>
                            到货列表导出Excel，JR导出时显示非产品项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-08-04</h4>
                    <ul>
                        <li>
                            账单导出设置，导出提货单增加是否显示Customs tariff number的控制。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-07-30</h4>
                    <ul>
                        <li>
                            订单详情页增加，按账单客户导出订单模板。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-07-16</h4>
                    <ul>
                        <li>
                            发送询价时，支持设置多个抄送邮箱地址。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-07-08</h4>
                    <ul>
                        <li>
                            收到账单-关联订单，增加显示利润率列。
                        </li>
                        <li>
                            Bug 修复：创建的分单产品错误显示到另一个产品下面。（前端显示问题）
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-23</h4>
                    <ul>
                        <li>
                            订单详情-添加产品,增加AI识别自然语言添加型号。
                        </li>
                        <li>
                            收到账单(AI)详情-订单预览，增加收到账单模块。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-18</h4>
                    <ul>
                        <li>
                            询价列表-创建按钮，优化AI识别逻辑和QQ Bot一样。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-17</h4>
                    <ul>
                        <li>
                            收到账单-导入 SEPA 付款文件,显示项优化。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-13</h4>
                    <ul>
                        <li>
                            合同列表增加导出产品按钮。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-12</h4>
                    <ul>
                        <li>
                            导航栏增加 office ai bot 图标，点击后支持以对话方式与系统数据交互。（限制了只可读取数据，禁止修改数据）
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-10</h4>
                    <ul>
                        <li>
                            收到账单(AI)列表,支持勾选删除。筛选项默认选中待确认。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-08</h4>
                    <ul>
                        <li>
                            支持设置 2FA 动态验证码，右上角昵称 - 登陆安全设置 中可开启 2FA 登陆动态验证码。
                        </li>
                        <li>
                            收到账单详情页UI排版优化。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-05</h4>
                    <ul>
                        <li>
                            收到账单支持导入SEPA XML,批量设置账单状态,订单状态。
                        </li>
                        <li>
                            收到账单列表数据统计和筛选项 UI 排版优化。列表&详情页优化移动端排版。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-02</h4>
                    <ul>
                        <li>
                            UI排版优化: 货物图片上传组件、关联订单/账单组件、收到账单组件
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-06-01</h4>
                    <ul>
                        <li>
                            优化留言排版。
                        </li>
                        <li>
                            优化订单页勾选项UI。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-05-29</h4>
                    <ul>
                        <li>
                            优化订单页排版。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-05-28</h4>
                    <ul>
                        <li>
                            优化账单页、合同页排版。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-05-20</h4>
                    <ul>
                        <li>
                            账单详情页增加导出催账单PDF功能。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-05-19</h4>
                    <ul>
                        <li>
                            增加 订单-取货物流 功能，可通过cargoboard.com下单物流。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-05-13</h4>
                    <ul>
                        <li>
                            少货列表的数量，同时计算分出来的子项的到货数量。
                        </li>
                        <li>
                            订单详情页的实际/预计货期，显示具体日期范围。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-29</h4>
                    <ul>
                        <li>
                            移动端排版优化（列表+详情）：询价、订单、账单、合同。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-24</h4>
                    <ul>
                        <li>
                            页面排版优化：询价、订单、合同。
                        </li>
                        <li>
                            报价增加高级导出按钮，支持勾选产品+选择币种，导出报价单。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-23</h4>
                    <ul>
                        <li>
                            Invoice页面排版优化。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-14</h4>
                    <ul>
                        <li>
                            Invoice增加Excel导入批量修改重量功能，导入时支持预览和选择列。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-10</h4>
                    <ul>
                        <li>
                            优化少货操作流程：https://office.aoidata.com/wiki/43
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-09</h4>
                    <ul>
                        <li>
                            产品支持绑定最多三级账单，更清晰的层级显示。
                        </li>
                        <li>
                            订单-右上角关联模块，售价列计算规则调整。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-08</h4>
                    <ul>
                        <li>
                            收到账单（AI） ，详情页优化，更容易操作。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-04-02</h4>
                    <ul>
                        <li>
                            订单-Excel导入产品，增加THINKFON模板支持。
                        </li>
                        <li>
                            订单-小工具增加【设置账单】，可选择账单和加点，批量选择产品设置账单和账单金额。
                        </li>
                        <li>
                            合同货期包含小数点时不显示Week周后缀。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-03-27</h4>
                    <ul>
                        <li>
                            增加 收到账单（AI） 列表，buchhaltung@aoi-solutions.com 标题中包含 invoice / rechnung 并且包含PDF附件的邮件会自动出现在该列表。
                        </li>
                        <li>
                            在  收到账单（AI） 列表的邮件，系统会自动解析账单PDF并匹配系统产品，方便快捷录入。
                        </li>
                        <li>
                            AI可能出错，请务必审核数据是否正确。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-03-22</h4>
                    <ul>
                        <li>
                            invoicee导出海关XML更新：
                        </li>
                        <li>
                            1. 总价保留2位小数。
                        </li>
                        <li>
                            2. previousProcedure，欧盟国家 00，非欧盟国家 40 。（按原产地计算）
                        </li>
                        <li>
                            3. 原产地，如果是USA，XML会显示US，UK会显示GB。
                        </li>
                        <li>
                            4. Origin-regionOfDispatch，其他国家是99，德国的话，会使用所选的城市编码。（产品原产地选择德国后，支持选择城市）
                        </li>
                        <li>
                            5. 税号管理支持导入通过海关的XML文件，记录税号条款，以便后续导出该税号时，自动应用税号条款。
                        </li>
                    </ul>
                </>
            },
            {
                children: <>
                    <h4>2026-03-16</h4>
                    <ul>
                        <li>
                            修复：contract合同详情页，点击编辑，然后再点取消。然后点下面产品的订单号，地址栏地址变了，但是页面没有跳转到订单详情页。
                        </li>
                        <li>
                            invoice复开账单支持设置汇率。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-02-28</h4>
                    <ul>
                        <li>
                            留言提醒优化：小喇叭数字支持同时显示【发起待处理/@我】两类截止日期告警数量。
                        </li>
                        <li>
                            导航栏留言展开的侧边栏，支持按【全部/已过期/2天内到期】筛选，支持点击顶部汇总直接跳转到对应Tab并触发筛选。
                        </li>
                        <li>
                            新增留言，@同事情况下，支持设置截止日期。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-02-26</h4>
                    <ul>
                        <li>
                            Invoice:
                        </li>
                        <li>
                            运输方式的BL No.输入框位置调整优化。
                        </li>
                        <li>
                            空运也支持输入追踪号，自动追踪海关信息。
                        </li>
                        <li>
                            海运/空运，增加去查询按钮，打开对应船东查询页面。
                        </li>
                        <li>
                            优化保存产品时，如果产品被同事改过，提示刷新页面的逻辑与界面UI。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-02-05</h4>
                    <ul>
                        <li>
                            我的留言（未处理/已处理）、留言@我的，展开列表显示优化。
                        </li>
                        <li>
                            [产品到货]少于[产品收到账单到货]邮件，增加显示中文备注。优化Excel排版。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-02-03</h4>
                    <ul>
                        <li>
                            gemu品牌的产品新增/修改后，会自动通过官网查询价格同步到系统。
                            稍后刷新订单页面，会出现抓取到的价格，鼠标悬浮会显示来源和网页截图。
                            可以手动点击采纳按钮，快速填充设置为采购价格。
                            （支持订单和询价）
                        </li>
                        <li>
                            自动价格查询支持阶梯报价，以及自动匹配阶梯报价提供采纳，支持品牌：gutekunst
                        </li>
                        <li>
                            Tower自动订单支持HJJ。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-01-28</h4>
                    <ul>
                        <li>
                            Tower创建订单流程自动化（QC、DL），可以直接在系统订单中查看和管理Tower创建的订单。
                        </li>
                        <li>
                            订单详情页-小工具那里增加催账单按钮，支持查看邮件模板和发送邮件。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-01-27</h4>
                    <ul>
                        {/* <li>
                            订单详情页，添加分单产品时，如果父产品有收到账单，则把数量减少并分配到分单产品中。(界面有明确提示)
                        </li> */}
                        <li>
                            订单详情页，产品-收到账单-添加收到账单时，选项把最新的排在前面，并在选项显示更多信息方便快速定位账单。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-01-22</h4>
                    <ul>
                        <li>
                            库存管理列表的库存来源加上跳转订单链接。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-01-13</h4>
                    <ul>
                        <li>
                            到货情况，到货数量列如果没有全部到货，显示橙色，方便找到。
                        </li>
                        <li>
                            到货情况，选择未到货时，未全部到货的产品也要显示到列表。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2026-01-13</h4>
                    <ul>
                        <li>
                        账单-创建复开账单弹窗，显示已创建过的复开账单，防止重复创建复开账单。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-12-15</h4>
                    <ul>
                        <li>
                        系统所有留言的文件上传，支持选择多个文件直接拖入留言窗口上传。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-11-11</h4>
                    <ul>
                        <li>
                        订单产品：新增“供应商货期（KW）”输入项，用于录入供应商报价的预计交期周数。
                        </li>
                        <li>
                        订单详情&订单列表：新增供应商报价预计货期展示与实际货期的对比，若实际货期延迟则标注感叹号，悬浮提示通知客户更新货期。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-11-05</h4>
                    <ul>
                        <li>
                            订单产品采购价增加英镑币种.
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-10-09</h4>
                    <ul>
                        <li>
                            Gutschrift列表，增加品牌筛选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-09-28</h4>
                    <ul>
                        <li>
                            收到账单增加[Gutschrift]选项。列表可过滤。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-09-23</h4>
                    <ul>
                        <li>
                            询价列表，催询价邮件支持设定发送时间。
                        </li>
                        <li>
                            订单列表，增加合同状态筛选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-09-17</h4>
                    <ul>
                        <li>
                            库存管理增加生产日期项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-09-16</h4>
                    <ul>
                        <li>
                            询价列表，对超过3个工作日未报价的询价可勾选并发送催询价邮件。
                            <br />
                            早期询价的催询价会直接发送单独一封邮件。
                            <br />
                            更新后的询价会记录询价邮件ID，催询价邮件会在原邮件基础上追加发送。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-09-10</h4>
                    <ul>
                        <li>
                            产品增加“运单服务费”选项。
                        </li>
                        <li>
                            询价列表对超过3个工作日未报价的询价显示红色感叹号。(去除德国节假日)
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-09-01</h4>
                    <ul>
                        <li>
                            订单产品增加[需要Gutschrift][收到Gutschrift]选项。
                        </li>
                        <li>
                            菜单栏订单下增加[Gutschrift列表]。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-08-22</h4>
                    <ul>
                        <li>
                            只勾选了到货没有输入数量的全部到货情况，订单界面展示时也展示具体到货数量，方便核对。
                        </li>
                        <li>
                            订单邮件,界面显示+PDF，Pos不按顺序显示，对应订单Pos显示。多个订单的情况，多一行所属订单用来分隔。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-08-13</h4>
                    <ul>
                        <li>
                            采购单价支持选择币种，汇总分币种显示。订单总金额分币种计算与显示。只会显示有金额的币种。
                        </li>
                        <li>
                            其他修改位置: 订单邮件、订单列表与导出、搜索结果、到货列表与PDF、到货情况列表与导出、货列表列表与导出。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-08-06</h4>
                    <ul>
                        <li>
                            到货情况列表增加收到账单筛选项与Excel导出。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-07-25</h4>
                    <ul>
                        <li>
                            首次到货时间会记录在系统，并在【AOI 到货】的首次到货时间列显示，支持倒序排列。
                        </li>
                        <li>
                            未选择账单/复开账单，但输入了账单售价/复开账单售价，保存时会红框warning提示要选择账单/复开账单。<br />
                            选择了账单未输入售价也会提示。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-07-04</h4>
                    <ul>
                        <li>
                            产品增加“软件产品/证书”选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-07-03</h4>
                    <ul>
                        <li>
                            关联库存逻辑改为多选。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-07-01</h4>
                    <ul>
                        <li>
                            合同列表增加增值税筛选过滤。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-06-13</h4>
                    <ul>
                        <li>
                            合同列表月份筛选支持多选。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-06-06</h4>
                    <ul>
                        <li>
                            合同列表可批量勾选，快捷查看勾选的合同总金额、预付总金额。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-05-28</h4>
                    <ul>
                        <li>
                            账单列表隐藏合同号。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-05-23</h4>
                    <ul>
                        <li>
                            订单产品注意事项，新增【不完整包装】、【下单提醒供货商打包好再发】选项。
                        </li>
                        <li>
                            账单报关状态，增加【无需报关】选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-05-20</h4>
                    <ul>
                        <li>
                            Wiki页面右下角增加问答bot。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-05-09</h4>
                    <ul>
                        <li>
                            invoice海运可输入BL追踪号，自动追踪ETA。(货物所在地=国际运输途中)
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-04-28</h4>
                    <ul>
                        <li>
                            订单页，产品新增/编辑，添加【注意事项】（多选）。<br />
                            产品新添加时，会自动选中之前的注意事项。（同品牌同型号）
                        </li>
                        <li>
                            注意事项会在以下位置显示：<br />
                            1. 账单发货单（excel）<br />
                            2. 订单packing list（pdf）<br />
                            3. 订单/账单/合同 详情页，产品如果有注意事项，会显示⚠️图标，鼠标移动上去会显示注意事项。<br />
                            4. 会在微信小程序中对应产品位置显示。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-04-22</h4>
                    <ul>
                        <li>
                            创建复开账单时，自动设置原账单的产品的复开账单。创建时可以设置产品单价。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-04-17</h4>
                    <ul>
                        <li>
                            Invoice列表只显示aoi和neo汇总金额、DHL下单Reference显示Invoice+订单号
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-04-13</h4>
                    <ul>
                        <li>
                            产品增加复开账单选项，账单可快捷创建复开账单。Wiki:
                            <a href={'/wiki/34'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-04-11</h4>
                    <ul>
                        <li>
                            订单列表、订单详情、搜索结果的订单号，采购公司是neosolis时显示绿色区分。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-03-25</h4>
                    <ul>
                        <li>
                            订单列表，批量发送邮件功能，增加【催货期】邮件模板。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-03-24</h4>
                    <ul>
                        <li>
                            【AOI 到货】列表，增加【显示国内库存到货】勾选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-03-18</h4>
                    <ul>
                        <li>
                            采购公司增加 Neosolis
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-02-19</h4>
                    <ul>
                        <li>
                            托盘管理,REXROTH 品牌的产品也支持分托盘设置数量。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-02-18</h4>
                    <ul>
                        <li>
                            订单详情页，通过添加分单按钮创建的产品，会默认选中父产品的合同和账单。
                        </li>
                        <li>
                            创建订单页，同时创建合同选项：增值税默认为13%，可同时设置合同是否为国内现货。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-02-06</h4>
                    <ul>
                        <li>
                            新增规则：用了国内到货的库存，就不能点到货。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-02-05</h4>
                    <ul>
                        <li>
                            账单添加了备注输入项，会显示在Invoice PDF中。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-01-22</h4>
                    <ul>
                        <li>
                            到货情况页面，订单时间筛选项支持多选。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-01-14</h4>
                    <ul>
                        <li>
                            产品Hover会显示修改记录按钮，点击可查看修改记录。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2025-01-08</h4>
                    <ul>
                        <li>
                            询价显示计划发送时间。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-27</h4>
                    <ul>
                        <li>
                            订单图片，增加上传视频和播放视频功能。
                            <br />
                            微信小程序支持拍照/录像上传，且不会保存在本地相册。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-25</h4>
                    <ul>
                        <li>
                            发送询价功能，输入延迟小时数改为选择发送日期。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-18</h4>
                    <ul>
                        <li>
                            Invoice导出海关XML文件调整。
                            <br />
                            之前: 重量小于2时，默认显示1。 重量大于等于2时，取整。
                            <br />
                            现在：始终显示填写的重量，包含小数。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-17</h4>
                    <ul>
                        <li>
                            订单产品增加【供货商折扣】选项。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-10</h4>
                    <ul>
                        <li>
                            订单产品增加【添加分单】功能，分单产品在订单页Pos号会以一级产品的Pos+0.1这样来显示，例如：2.1、2.2。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-09</h4>
                    <ul>
                        <li>
                            对订单、合同、账单列表、以及对应产品列表做了一些“减法”，不直接用的功能做了收起。（勾选框、Excel导入、排序等）
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-06</h4>
                    <ul>
                        <li>
                            产品界面优化。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-12-04</h4>
                    <ul>
                        <li>
                            订单-产品，增加单件重量。总重量联动计算。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-27</h4>
                    <ul>
                        <li>
                            Invoice的产品编辑增加了一个勾选，勾选后自动同步设置同品牌型号四项信息【税号、描述、品名、3C】。（只会同步设置最早2024年的产品）
                        </li>
                        <li>
                            编辑保存产品，加了一个校验，如果保存的这个产品被他人改过，会提示产品有修改，请刷新页面重新保存，防止覆盖他人的修改。（多人同时操作一个order/contract/invoice页面内产品的场景）
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-26</h4>
                    <ul>
                        <li>
                            【已回退】订单-产品,鼠标移动到某个产品时,会显示copy图标,点击后会自动滑动到创建表单位置,自动填充创建表单。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-25</h4>
                    <ul>
                        <li>
                            【已回退,会导致PnDA留言与产品顺序对不上】订单-产品，创建产品时，如果型号有一样的，自动排序跟在已有相同型号下面。
                        </li>
                        <li>
                            订单-邮件图标按钮,导出PDF现在支持选择无运费版。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-21</h4>
                    <ul>
                        <li>
                            订单详情页，当前登录用户被@的信息(且未被标记为已处理时),会以Top突出方式显示。(微信小程序已同步更新,打开后登录状态会自动注销,需要在个人中心重新登录)
                        </li>
                        <li>
                            订单详情页,Top置顶的留言,取消置顶时会同时标记为已处理。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-20</h4>
                    <ul>
                        <li>
                            询价-详情页-型号: 现在一个型号的多个附件,如果是图片和其他文件格式混合,其中的图片也会显示预览图。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-14</h4>
                    <ul>
                        <li>
                            合同-详情页: 如果增值稅选的0%,保存合同后,合同号码自动增加NV后缀。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-12</h4>
                    <ul>
                        <li>
                            订单-详情页-订单邮件: 增加复制按钮。（可以一键复制内容，粘贴到outlook邮件里）
                        </li>
                        <li>
                            订单-详情页-产品: 仓储同事现在可以设置产品塞货账单。
                        </li>
                        <li>
                            箱单-托盘: 现在支持在详情页导入Excel，通过Excel快速设置产品所在托盘与箱号。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-11-04</h4>
                    <ul>
                        <li>
                            订单-详情页-产品Excel导入: D列合同价如果不需要导入，导入前删除D列即可。导入选项-合同币种，改为了非必须，默认是空。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-10-25</h4>
                    <ul>
                        <li>
                            订单-详情页: 关联订单,手动关联超过1个时,该订单将自动变更状态为主订单。取消关联所有订单后，会自动取消主订单状态。
                        </li>
                        <li>
                            订单-详情页: 订单邮件按钮，主订单里的产品#序列号列,现在会从1开始按顺序显示。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-10-15</h4>
                    <ul>
                        <li>
                            托盘管理-详情页: 增加搜索功能，可输入产品型号或订单号，快速查看所在托盘和箱号。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-10-14</h4>
                    <ul>
                        <li>
                            订单详情页-产品: 增加[计划塞货]勾选项(表示需要塞货，但塞货的账单还没出现),订单-订单到货列表增加计划塞货过滤选项。Wiki:
                            <a href={'/wiki/31'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-09-30</h4>
                    <ul>
                        <li>
                            订单详情页-产品: 编辑产品到货/到货数量时，会自动计算到货情况到留言编辑框：PnDA/Pn(本次到货数)DA。Wiki:
                            <a href={'/wiki/30'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-09-26</h4>
                    <ul>
                        <li>
                            <Space direction="vertical">
                                <span>订单-详情页: </span>
                                <span>所有产品<Text type="success">全部到货</Text>后，<Text strong>订单主体状态</Text>自动变更：</span>
                                <Text keyboard><span style={{ color: '#000' }}>“订单到货状态” {'==>'} “全部到货”</span></Text>
                                <Text keyboard><span style={{ color: '#000' }}>“订单状态” {'==>'} “货到请付款”</span></Text>
                                <Text underline>注意，订单状态是【订单仍未下单、等待订单确认、PR需要预付、PR预付完成、确认收到等货】状态之一时才会执行变更。</Text>
                                <Divider />
                                <span>所有产品全部到货情况下，某个产品的状态更改为<Text type="warning">部分到货</Text>后，订单主体状态自动变更：</span>
                                <Text keyboard><span style={{ color: '#000' }}>“订单到货状态” {'==>'} “部分到货”</span></Text>
                                <Text keyboard><span style={{ color: '#000' }}>“订单状态” {'==>'} “确认收到等货”</span></Text>
                                <Text underline>注意，订单状态是【货到请付款】状态时才会执行变更。</Text>
                            </Space>
                        </li>
                        <li>
                            产品编辑: 到货数量、重量，新增快捷加/减操作，避免增加和减少要手动计算。Wiki:
                            <a href={'/wiki/29'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-09-24</h4>
                    <ul>
                        <li>
                            订单-库存管理，table底部增加库存总结，筛选项增加库存位置筛选。
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-09-23</h4>
                    <ul>
                        <li>
                            订单-产品Excel导入功能，新增D列合同单价导入项。Wiki:
                            <a href={'/wiki/26'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                        <li>
                            运营-邮件AI翻译，增加提示词选项{'<'}修正德语语法和单词{'>'}。
                        </li>
                        <li>
                            顶部菜单栏增加更新日志按钮。Wiki:
                            <a href={'/wiki/27'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                    </ul>
                </>,
            },
            {
                children: <>
                    <h4>2024-09-19</h4>
                    <ul>
                        <li>
                            订单详情页的图片，新增批量勾选下载原图功能。Wiki:
                            <a href={'/wiki/28'} target='_blank'>{'<'}功能说明{'>'}</a>
                        </li>
                    </ul>
                </>,
            },
        ];
    }

    renderHomeRoute = (props) => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        return token ? <Home {...props} /> : <Redirect to="/login" />;
    }

    // 受保护路由：无 token 时跳转登录页
    PrivateRoute = ({ component: Comp, render: renderFn, ...rest }) => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        return (
            <Route
                {...rest}
                render={(props) =>
                    token
                        ? (Comp ? <Comp {...props} /> : renderFn(props))
                        : <Redirect to="/login" />
                }
            />
        );
    }

    render() {
        // 检测是否为测试环境
        const isDevEnvironment = window.location.hostname.includes('dev');
        
        return (
            <>
                <ConfigProvider locale={zhCN} theme={antdTheme}>
                <StyleProvider hashPriority="high">
                <CookiesProvider>
                    {isDevEnvironment && (
                        <div style={{
                            backgroundColor: '#ff9800',
                            color: '#fff',
                            textAlign: 'center',
                            padding: '6px 12px',
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}>
                            ⚠️ 当前为测试环境 (DEV) - 数据可能会被重置
                        </div>
                    )}
                    <Router history={history}>
                        <Switch>
                            <Route exact path="/" render={this.renderHomeRoute} />
                            <this.PrivateRoute path="/orders" component={(props) => <Orders {...props} />} />
                            <this.PrivateRoute path="/freights" component={(props) => <Freights {...props} />} />
                            <this.PrivateRoute path="/transfers" component={(props) => <Transfers {...props} />} />
                            <this.PrivateRoute path="/freight/create" component={(props) => <FreightCreate {...props} />} />
                            <this.PrivateRoute path="/transfer/create" component={(props) => <TransferCreate {...props} />} />
                            <this.PrivateRoute path="/transfer/:id" component={(props) => <Transfer {...props} />} />
                            <this.PrivateRoute path="/freight/:id" component={(props) => <Freight {...props} />} />
                            <this.PrivateRoute path="/pickups"        component={(props) => <Pickups {...props} />} />
                            <this.PrivateRoute path="/pickup/:id"     component={(props) => <Pickup {...props} />} />
                            <this.PrivateRoute path="/order/create" component={(props) => <OrderCreatePage {...props} />} />
                            <this.PrivateRoute path="/order/stock/create" component={(props) => <StockCreatePage {...props} />} />
                            <this.PrivateRoute path="/order/stock/:id" component={(props) => <Stock {...props} />} />
                            <this.PrivateRoute path="/order/stocks" component={(props) => <Stocks {...props} />} />
                            <this.PrivateRoute path="/order/gutschrift" component={(props) => <Gutschrift {...props} />} />
                            <this.PrivateRoute path="/order/short-products" component={(props) => <ShortProducts {...props} />} />
                            <this.PrivateRoute path="/order/:id" component={(props) => <Order {...props} />} />
                            <this.PrivateRoute path="/storage/order/:id" component={(props) => <StorageOrder {...props} />} />
                            <this.PrivateRoute path="/storage" component={(props) => <Storage {...props} />} />
                            <this.PrivateRoute path="/inventory" component={(props) => <Inventory {...props} />} />
                            <this.PrivateRoute path="/delivery" component={(props) => <Delivery {...props} />} />
                            <this.PrivateRoute path="/StorageOverview" component={(props) => <StorageOverview {...props} />} />
                            <this.PrivateRoute path="/payments" component={(props) => <Payments {...props} />} />
                            <this.PrivateRoute path="/waybills" component={(props) => <Waybills {...props} />} />
                            <this.PrivateRoute path="/todolist" component={(props) => <Todolist {...props} />} />
                            <this.PrivateRoute path="/waybill/create" component={(props) => <WaybillCreate {...props} />} />
                            <this.PrivateRoute path="/sticker/create" component={(props) => <WaybillStickerCreate {...props} />} />
                            <this.PrivateRoute path="/waybill/:id" component={(props) => <Waybill {...props} />} />
                            <this.PrivateRoute path="/payment/create" component={(props) => <PaymentCreate {...props} />} />
                            <this.PrivateRoute path="/paymentProformas" component={(props) => <PaymentProformas {...props} />} />
                            <this.PrivateRoute path="/auto-invoices" component={(props) => <AutoInvoices {...props} />} />
                            <this.PrivateRoute path="/auto-invoice/:id" component={(props) => <AutoInvoiceDetail {...props} />} />
                            <this.PrivateRoute path="/payment/:id" component={(props) => <Payment {...props} />} />
                            <this.PrivateRoute path="/hscodes" component={(props) => <Hscodes {...props} />} />
                            <this.PrivateRoute path="/hscode/create" component={(props) => <HscodeCreate {...props} />} />
                            <this.PrivateRoute path="/hscode/:id" component={(props) => <Hscode {...props} />} />
                            <this.PrivateRoute path="/incomes" component={(props) => <Incomes {...props} />} />
                            <this.PrivateRoute path="/income/create" component={(props) => <IncomeCreate {...props} />} />
                            <this.PrivateRoute path="/income/:id" component={(props) => <Income {...props} />} />
                            <this.PrivateRoute path="/ztns" component={(props) => <Ztns {...props} />} />
                            <this.PrivateRoute path="/ztn/create" component={(props) => <ZtnCreate {...props} />} />
                            <this.PrivateRoute path="/ztn/:id" component={(props) => <Ztn {...props} />} />
                            <this.PrivateRoute path="/tariffnumbers" component={(props) => <Tariffnumbers {...props} />} />
                            <this.PrivateRoute path="/brands" component={(props) => <Brands {...props} />} />
                            <this.PrivateRoute path="/brand/create" component={(props) => <BrandCreatePage {...props} />} />
                            <this.PrivateRoute path="/brand/:id" component={(props) => <Brand {...props} />} />
                            <Route path="/login" component={(props) => <Login {...props} />} />
                            <Route path="/logout" component={(props) => <Logout {...props} />} />
                            <this.PrivateRoute path="/resources" component={(props) => <Resources {...props} />} />
                            <this.PrivateRoute path="/resource/create" component={(props) => <ResourceCreatePage {...props} />} />
                            <this.PrivateRoute path="/resource/:id" component={(props) => <Resource {...props} />} />
                            <this.PrivateRoute path="/clients" component={(props) => <Clients {...props} />} />
                            <this.PrivateRoute path="/client/create" component={(props) => <ClientCreatePage {...props} />} />
                            <this.PrivateRoute path="/client/:id" component={(props) => <Client {...props} />} />
                            <this.PrivateRoute path="/buys" component={(props) => <Buys {...props} />} />
                            <this.PrivateRoute path="/buy/create" component={(props) => <BuyCreatePage {...props} />} />
                            <this.PrivateRoute path="/buy/:id" component={(props) => <Buy {...props} />} />
                            <this.PrivateRoute path="/invoices" component={(props) => <Invoices {...props} />} />
                            <this.PrivateRoute path="/invoice/create" component={(props) => <InvoiceCreatePage {...props} />} />
                            <this.PrivateRoute path="/invoice/delivery" component={(props) => <InvoiceDelivery {...props} />} />
                            <this.PrivateRoute path="/invoice/:id" component={(props) => <Invoice {...props} />} />
                            <this.PrivateRoute path="/report/logistics" component={(props) => <ReportLogistics {...props} />} />
                            <this.PrivateRoute path="/report/logistic/create" component={(props) => <ReportLogisticCreatePage {...props} />} />
                            <this.PrivateRoute path="/report/logistic/:id" component={(props) => <ReportLogistic {...props} />} />
                            <this.PrivateRoute path="/report/offices" component={(props) => <ReportOffices {...props} />} />
                            <this.PrivateRoute path="/report/office/create" component={(props) => <ReportOfficeCreatePage {...props} />} />
                            <this.PrivateRoute path="/report/office/:id" component={(props) => <ReportOffice {...props} />} />
                            <this.PrivateRoute path="/report/vacations" component={(props) => <ReportVacations {...props} />} />
                            <this.PrivateRoute path="/report/worktime" component={(props) => <ReportWorkTime {...props} />} />
                            <this.PrivateRoute path="/report/vacation/create" component={(props) => <ReportVacationCreatePage {...props} />} />
                            <this.PrivateRoute path="/report/vacation/:id" component={(props) => <ReportVacation {...props} />} />
                            <this.PrivateRoute path="/categories" component={(props) => <Categories {...props} />} />
                            <this.PrivateRoute path="/category/create" component={(props) => <CategoryCreatePage {...props} />} />
                            <this.PrivateRoute path="/category/:id" component={(props) => <Category {...props} />} />
                            <this.PrivateRoute path="/contract/create" component={(props) => <ContractCreatePage {...props} />} />
                            <this.PrivateRoute path="/contract/analysis" component={(props) => <ContractAnalysisPage {...props} />} />
                            <this.PrivateRoute path="/contracts" component={(props) => <Contracts {...props} />} />
                            <this.PrivateRoute path="/contract/:id" component={(props) => <Contract {...props} />} />
                            <this.PrivateRoute path="/inquiry/:id" component={(props) => <Inquiry {...props} />} />
                            <this.PrivateRoute path="/inquiries" component={(props) => <Inquiries {...props} />} />
                            <this.PrivateRoute path="/members" component={(props) => <Members {...props} />} />
                            <this.PrivateRoute path="/user" component={(props) => <User {...props} />} />
                            <this.PrivateRoute path="/UserSecurity" component={(props) => <UserSecurity {...props} />} />
                            <this.PrivateRoute path="/admin/users" component={(props) => <BlockUsers {...props} />} />
                            <this.PrivateRoute path="/admin/permissions" component={(props) => <Permissions {...props} />} />
                            <this.PrivateRoute path="/prices" component={(props) => <Prices {...props} />} />
                            <this.PrivateRoute path="/price/:id" component={(props) => <Price {...props} />} />
                            <this.PrivateRoute path="/discounts" component={(props) => <Discounts {...props} />} />
                            <this.PrivateRoute path="/discount/:id" component={(props) => <Discount {...props} />} />
                            <this.PrivateRoute path="/refs" component={(props) => <Refs {...props} />} />
                            <this.PrivateRoute path="/analysis/:id" component={(props) => <AnalysisInfo {...props} />} />
                            <this.PrivateRoute path="/analysis" component={(props) => <Analysis {...props} />} />
                            <this.PrivateRoute path="/back/orders" component={(props) => <BackOrders {...props} />} />
                            <this.PrivateRoute path="/back/order/create" component={(props) => <BackOrderCreatePage {...props} />} />
                            <this.PrivateRoute path="/back/order/:id" component={(props) => <BackOrder {...props} />} />
                            <this.PrivateRoute path="/wikis" component={(props) => <Wikis {...props} />} />
                            <this.PrivateRoute path="/wiki/create" component={(props) => <WikiCreate {...props} />} />
                            <this.PrivateRoute path="/wiki/:id" component={(props) => <Wiki {...props} />} />
                            <this.PrivateRoute path="/tools/translate" component={(props) => <Translate {...props} />} />
                            <this.PrivateRoute path="/tors" component={(props) => <Tors {...props} />} />
                            <this.PrivateRoute path="/tor/:id" component={(props) => <Tor {...props} />} />
                            {/* <Route path="/pdf_extracts" component={(props) => <PdfExtracts {...props} />} />
                            <Route path="/pdf_extract/:id" component={(props) => <PdfExtract {...props} />} /> */}
                        </Switch>
                    </Router>
                </CookiesProvider>
                <MessageBar />
                <FloatButton.BackTop className='backTopStyle' shape='shape' icon={<UpOutlined />} />
                </StyleProvider>
                </ConfigProvider>
            </>
        )

    }
}

export default App;
